import { createApp } from 'vue';
import { createPinia } from 'pinia';
// Inter als lokale Schrift (kein CDN) — dieselbe Familie wie in den Design-Tokens.
import '@fontsource-variable/inter';
import './styles/global.css';
import App from './App.vue';
import { router } from './router';

createApp(App).use(createPinia()).use(router).mount('#app');
